import { render, staticRenderFns } from "./ConsultasForm.vue?vue&type=template&id=75f27dac"
import script from "./ConsultasForm.vue?vue&type=script&lang=js"
export * from "./ConsultasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports